// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


//effetto testuale su cover
document.addEventListener('DOMContentLoaded', function (event) {
	// array with texts to type in typewriter
	var dataText = [
		'alle donne perché mancano ancora i fatti. perché la loro autonomia è la garanzia di tenuta della democrazia e dei diritti di ogni persona. lo sguardo e i traguardi paritari allargano, includono, uniscono.',
		'di dare valore alle ragazze e ai ragazzi del PD, dei movimenti e del volontariato, riconoscere i loro luoghi, programmi, canzoni, la loro libertà anche nella scelta delle loro e dei loro rappresentanti dentro segreterie e istituzioni.',
		'di unire le generazioni e riconoscere ovunque a partire dalle RSA come tra noi, il valore dell’età che è memoria, esperienza e civiltà.',
		'è essere intransigenti sui beni comuni e sull’etica pubblica contro ogni illegalità e corruzione. è voler bene alla bellezza e sicurezza di questo paese. è dire una volta per tutte che affitti fuori misura e speculazione non sono accettabili per giovani, piccoli artigiani, famiglie che contano gli euro della spesa.',
		'vuol dire che ogni traguardo, ogni lotta, ogni circolo non debbano mai più fare a meno di cultura e formazione. Perché la sinistra e la politica imparino ad ascoltare anche domande di senso e di spiritualità.',
		'significa che il PD riprende la tessitura di un nuovo centrosinistra politico, civico e ideale.',
		'per noi è un’ansia permanente di pace, dialogo tra le religioni. È un impegno totale per il primato dei diritti umani nel loro intreccio tra diritti sociali, civili e politici a prevalere sugli interessi selvaggi e sui privilegi.',
		'nella dignità di una vera cittadinanza per i disabili che  hanno molto da insegnare anche a chi non vuole capire quanto la loro umanità, intelligenza e i loro bisogni siano un punto di forza per la sostenibilità e coesione del paese, per il lavoro e per un futuro migliore per tutti. ',
		'per contrastare la povertà educativa attraverso la diffusione omogenea dei nidi su tutto il territorio nazionale, il potenziamento del diritto allo studio, l’accesso gratuito alle mense scolastiche e la gratuità dei libri di testo per le famiglie in difficoltà, restituendo ai docenti la dignità che meritano adeguando gli stipendi alla media europea e con investimenti robusti nell’edilizia scolastica.'
	];

	// type one text in the typwriter
	// keeps calling itself until the text is finished
	function typeWriter(text, i, fnCallback) {
		// chekc if text isn't finished yet
		if (i < (text.length)) {
			// add next character to h1
			document.querySelector(".text-animate").innerHTML = text.substring(0, i + 1) + '<span aria-hidden="true"></span>';

			// wait for a while and call this function again for next character 
			setTimeout(function () {
				typeWriter(text, i + 1, fnCallback)
			}, 50);
			//velocità fra le lettere
		}
		// text finished, call callback if there is a callback function
		else if (typeof fnCallback == 'function') {
			// call callback after timeout
			setTimeout(fnCallback, 2800);
			//tempo fra una farse a la successiva
		}
	}
	// start a typewriter animation for a text in the dataText array
	function StartTextAnimation(i) {
		if (typeof dataText[i] == 'undefined') {
			setTimeout(function () {
				StartTextAnimation(0);
			}, 2000);
			//tempo attesa èrima che ricominci tutto daccapo
		}
		// check if dataText[i] exists
		if (i < dataText[i].length) {
			// text exists! start typewriter animation
			typeWriter(dataText[i], 0, function () {
				// after callback (and whole text has been animated), start next text
				StartTextAnimation(i + 1);
			});
		}
	}
	// start the text animation
	StartTextAnimation(0);
});

//effetto testuale su cover